import { createSlice } from "@reduxjs/toolkit";
import { getBannerPositionList } from "./thunk";

export interface IState {
  lstBannerPosition: any;
  isBannerPositionLoading: boolean;
  isBannerPositionSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstBannerPosition: null,
  isBannerPositionLoading: false,
  isBannerPositionSuccess: false,

  error: {},
};

const BannerPositionSlice = createSlice({
  name: "BannerPosition",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBannerPositionList.pending, (state: IState, action: any) => {
      state.isBannerPositionLoading = true;
    });
    builder.addCase(
      getBannerPositionList.fulfilled,
      (state: IState, action: any) => {
        state.lstBannerPosition = action.payload.data;
        state.isBannerPositionSuccess = true;
        state.isBannerPositionLoading = false;
      }
    );
    builder.addCase(
      getBannerPositionList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isBannerPositionSuccess = false;
        state.isBannerPositionLoading = false;
      }
    );
  },
});

export default BannerPositionSlice.reducer;
